export const setMustChangePassword = mustChangePassword => {
	return { type: 'SET_MUST_CHANGE_PASSWORD', mustChangePassword };
};
